import React, { useState } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import '../components/PortfolioDesign.css'; // Ensure this path is correct
import '../App.css'; // Ensure this path is correct

const PortfolioDesign = ({ title, imageUrl, description, review, customerName, customerReview }) => {
    const [showModal, setShowModal] = useState(false);

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);

    return (
        <>
            <Row className="row-of-design mb-4">
                <Col lg={12} className="d-flex justify-content-center align-items-center text-center">
                    <h1 className="portfolio-h1">{title}</h1>
                </Col>
                <Col lg={8} className="mt-4">
                    <div className="logo-design-bg-color">
                        <img src={imageUrl} alt="logo design" style={{ height: '100%', width: '100%' }} onClick={openModal} />
                    </div>
                </Col>
                <Col lg={4}>
                    <div className="logo-design-portfolio-description">
                        <p className="logo-design-portfolio-description-p">{description}</p>
                    </div>
                    <div className="d-flex justify-content-end align-content-center mt-4">
                        <div className="d-flex justify-content-end align-items-center text-center mr-2 ml-2 mt-2">
                            <h3 className="portfolio-h3">{review.toFixed(1)}</h3>
                        </div>
                        <div className="star d-flex justify-content-center align-items-center text-center">
                            {<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#cca314" className="bi bi-star-fill" viewBox="0 0 16 16">
                                <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                            </svg>}
                        </div>
                    </div>
                    <div className="portfolio-review mt-2">
                        <p className="portfolio-review-p"><b>{customerName}</b></p>
                        <p className="portfolio-review-p">{customerReview}</p>
                    </div>
                </Col>
            </Row>

            <Modal show={showModal} onHide={closeModal} fullscreen={true} dialogClassName="modal-custom-fade">
                <Modal.Header closeButton>
                    <Modal.Title>Full Size Image</Modal.Title>
                </Modal.Header>
                <Modal.Body className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                    <img src={imageUrl} alt="Expanded design" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default PortfolioDesign;
